module.exports = __webpack_public_path__ + "static/media/ca.b40f512d.svg";